import { render, staticRenderFns } from "./CustomPanSvg.vue?vue&type=template&id=081d245e"
import script from "./CustomPanSvg.vue?vue&type=script&lang=js"
export * from "./CustomPanSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports